import {IDS} from '../requirements-assessment-action-id.constants';
import { IDS as MASTER_DOC_LIST_IDS } from '../../master-doc-list/master-doc-list-action-id.constants';
import {TYPES} from "../requirements-assessment-action-type.constants";
import { TYPES as RCO_TYPES } from '../../accreditation-action-type.constants';
import * as EvidenceActions from '../requirements-assessment.actions';
import * as AccAction from '../../accreditation.actions';
import {GRID_FILTER, GRID_RELOAD} from "../../../../common/grid/grid.constants";
import get from 'lodash/get';
import moment from "moment";
import {formatDate} from "../../../../common/utils/util.date";
import {DATE_FORMAT} from "../../../../common/utils/util.constants";
import watch from "redux-watch";
import pick from "lodash/pick";
import {TAB_SELECT, TAB_SHOW} from "../../../../common/tabs/tabs.constants";

class EvidenceGroupDocRevisionRequestController {
    constructor($ngRedux,
                $state,
                $stateParams,
                $filter,
                $timeout,
                $transitions,
                Notifier,
                DocumentManager,
                EmployeeService,
                AuthService,
                FileActions,
                $scope) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$transitions = $transitions;
        this.Notifier = Notifier;
        this.DocumentManager = DocumentManager;
        this.EmployeeService = EmployeeService;
        this.AuthService = AuthService;
        this.FileActions = FileActions;
        this.identifier = IDS.rcoRequirementsAssessment;
        this.$scope = $scope;
    }

    $onInit() {
        this.schemeCode = this.$stateParams.itemCode;
        const user = this.AuthService.getUser();
        this.userUuid = user.uuid;
        this.isAdmin = user.type === 'Administrator';
        this.minDueDate = new Date();

        this.unsubscribe = this.$ngRedux.connect(state => {
            const accDashboardLocationYear = state.accreditation.accDashboardLocationYear;
            const subModule = state.accreditation[this.identifier];
            const details = subModule.evidenceDetails;
            const requirement = state.accreditation.selectedRequirement;

            return {
                details,
                requirementName: requirement?.name,
                requirementDescription: get(requirement, 'description', '')?.replace(/\n/g, '<br>'),
                fiscalYear: accDashboardLocationYear.year,
                locationName: subModule.selectedSiteLocation?.locationName,
                siteLocationUuid: subModule.selectedSiteLocation?.uuid,
                headOfficeUuid: subModule.selectedHeadOffice?.uuid,
                requirement,
                selectedAuditTask: this.isAdmin
                    ? subModule.selectedAuditTask
                    : subModule.auditors?.find(item => item.assignee_uuid === this.userUuid)?.uta_id,
                documentForRevisionRequest: subModule.documentForRevisionRequest,
                alsoAssignImprovementAction: subModule.alsoAssignImprovementAction,
                docRevisionRequest: subModule.docRevisionRequest,
                improvementAction: subModule.improvementAction,
                firstDocType: state.accreditation.common.documentTypes[0].value,
            }
        }, {
            ...AccAction,
            ...EvidenceActions,
            ...this.FileActions,
        })(this);

        const ctrl = this;
        this.$timeout(function() {
            let assignee;
            if(ctrl.details.review_task_assignee) {
                assignee = {
                    sub_uuid: ctrl.details.review_task_assignee_uuid,
                    name: ctrl.details.review_task_assignee
                };
                ctrl.$ngRedux.dispatch({
                    type: RCO_TYPES.FETCH_AUTOCO_EMPLOYEES_AND_MANAGERS,
                    path: `${ctrl.identifier}.${IDS.rcoEvidenceDocRevisionCandidates}`,
                    data: [assignee]
                });
            }
            ctrl.$ngRedux.dispatch({
                id: ctrl.identifier,
                type: TYPES.SET_DOC_REVISION_REQUEST_DETAILS,
                details: { assignee: {
                    ...assignee,
                    subject_uuid: assignee.sub_uuid,
                } }
            });
        }, 200);
    }

    async onAutocompleteKeywordQuery (keyword) {
        return await this.fetchEmployeesAndManagers(
            keyword,
            this.siteLocationUuid,
            `${this.identifier}.${IDS.rcoEvidenceDocRevisionCandidates}`,
        );
    }

    onSubmit() {
        const form = this.$scope.evgDocumentRevisionForm;
        if(form.$invalid) {
            this.Notifier.error('COMMON.FIELDS_REQUIRED');
            for (const item of form.$$controls) {
                if (item.$invalid) {
                    item.$setTouched();
                }
            }
            return;
        }
        const vdo_uuid = this.documentForRevisionRequest?.id || this.details?.vdo_uuid;
        if(!vdo_uuid || !this.selectedAuditTask) {
            return;
        }

        this.setDocumentAssessment({
            vdo_uuid,
            status_code:        'nap',
            evidence_group:     this.details.ard_id,
            requirement:        this.requirement?.id,
            slo_uuid:           this.siteLocationUuid,
            audit_task:         this.selectedAuditTask,
            revision_assignee:  this.docRevisionRequest.assignee.subject_uuid,
            revision_description: this.docRevisionRequest.description,
            revision_due_date:  formatDate(this.docRevisionRequest.dueDate, DATE_FORMAT.OUTPUT),
        }).then(() => {
            // this.$ngRedux.dispatch({
            //     type: GRID_RELOAD,
            //     id: this.identifier,
            //     path: IDS.rcoEvidenceGroupDocumentsGrid
            // });
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: this.identifier,
                path: IDS.rcoEvidenceGroupsProgressGrid
            });
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: this.identifier,
                path: IDS.rcoEvidenceGroupHistoryGrid
            });
            this.reloadDetailsAndStatuses();
            if(this.alsoAssignImprovementAction) {
                this.$ngRedux.dispatch({
                    type: TAB_SHOW,
                    id: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups,
                    state: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_improvement,
                });
            }
            else {
                this.$ngRedux.dispatch({
                    type: TAB_SELECT,
                    id: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups,
                    state: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_list,
                });
            }
            this.$ngRedux.dispatch({
                id: this.identifier,
                type: TYPES.SET_DOC_REVISION_REQUEST_DETAILS,
                details: {}
            });
            form.$setPristine();
            form.$setUntouched();
        });
    }

    reloadDetailsAndStatuses() {
        const requirementId = this.requirement?.id;
        const siteLocationUuid = this.siteLocationUuid;
        const year = this.fiscalYear;
        this.fetchRequirementAuditorStatuses(requirementId, siteLocationUuid, year, this.userUuid, this.details.ard_id)
        this.fetchEvidenceGroupsProgressGrid({requirementId, siteLocationUuid, year}).then(() => {
            this.$ngRedux.dispatch({
                type: TYPES.SELECT_EVIDENCE_DETAILS,
                ardId: this.details.ard_id,
                firstDocType: this.firstDocType,
            });
        });
    }

    onCancel() {
        this.$ngRedux.dispatch({
            type: TAB_SELECT,
            id: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups,
            state: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_list,
        });
    }

    $onDestroy() {
        if(this.unsubscribe)
            this.unsubscribe();
    }
}

EvidenceGroupDocRevisionRequestController.$inject = [
    '$ngRedux',
    '$state',
    '$stateParams',
    '$filter',
    '$timeout',
    '$transitions',
    'Notifier',
    'DocumentManager',
    'EmployeeService',
    'AuthService',
    'FileActions',
    '$scope']

export const evidenceGroupDocRevisionRequest = {
    controller: EvidenceGroupDocRevisionRequestController,
    template: `
    <div class="formHeader" layout-align="start center" style="margin-left: 20px;" flex>
        <h4>
            <div layout="row" layout-align="start center">
                <asset cls="colorAccreditations" src="rco-requirement.svg"></asset>
                <div style="padding-left: 5px;">{{$ctrl.requirementName}}</div>
            </div>
        </h4>
    </div>
    <div hide-md hide-sm hide-xs > </div>
    <div style="padding-left: 20px;">Requirement: {{$ctrl.requirementDescription}}
        <md-tooltip ng-if="$ctrl.filenameTooltip">{{$ctrl.filenameTooltip}}</md-tooltip>
    </div>
    <div layout="row" flex style="margin: 20px">
        <div layout-gt-xs="column" style="min-width:150px">
            <div class="accreditation-table-item md-body-1">{{'COMMON.FIELD.SITE_LOCATION' | translate}}:</div>
            <div class="accreditation-table-item md-body-1" ng-if="$ctrl.fiscalYear">{{'COMMON.DATE.FISCAL_YEAR' | translate}}:</div>
        </div>
        <span flex="5"></span>
        <div layout-gt-xs="column">
            <div class="accreditation-table-item md-body-1">{{$ctrl.locationName}}</div>
            <div class="accreditation-table-item md-body-1" ng-if="$ctrl.fiscalYear">{{$ctrl.fiscalYear}}</div>
        </div>
    </div>
    
    <div class="formHeader"  layout-align="start center" flex>
        <h4>
            <div layout="row" layout-align="start center" style="padding: 0 20px;">
                <asset cls="colorAccreditations" style="padding-right: 10px; scale:60%" src="rco-evidence-icon.svg"></asset>
                <div>{{$ctrl.details.doc_num}} - {{$ctrl.details.name}}</div>
                <div flex></div>
                <div><span>Status:</span> <span ng-style="{'color':$ctrl.evidenceStatusColor}">{{$ctrl.details.status_name}}</span></div>
            </div>
        </h4>
    </div>
    <div layout="row" flex style="margin: 20px">
        <p flex ng-bind-html="['Evidence: ' + ($ctrl.details.description || '...')].join(' ')"></p>
    </div>

    <h4>
        <div style="padding-left: 20px;">{{'ACCREDITATION.REQUIREMENTS.EVIDENCE_OWNER' | translate}}{{!$ctrl.details.review_task_id ? ' Is Not Set' : ''}}</div>
    </h4>
    <div layout="row" flex style="margin: 20px" ng-if="$ctrl.details.review_task_id">
        <div layout-gt-xs="column" style="min-width:150px">
            <div class="accreditation-table-item md-body-1">Assignee:</div>
            <div class="accreditation-table-item md-body-1">Status:</div>
            <div class="accreditation-table-item md-body-1">Due Date:</div>
            <div class="accreditation-table-item md-body-1">Created By:</div>
            <div class="accreditation-table-item md-body-1">Created At:</div>
        </div>
        <span flex="5"></span>
        <div layout-gt-xs="column">
            <div class="accreditation-table-item md-body-1">{{$ctrl.details.review_task_assignee}}</div>
            <div class="accreditation-table-item md-body-1">{{$ctrl.details.review_task_status_name}}</div>
            <div class="accreditation-table-item md-body-1">{{$ctrl.details.review_task_due_date}}</div>
            <div class="accreditation-table-item md-body-1">{{$ctrl.details.review_task_created_by}}</div>
            <div class="accreditation-table-item md-body-1">{{$ctrl.details.review_task_created_at}}</div>
        </div>
    </div>
    <div layout-margin></div>
    <md-divider></md-divider>
    <ng-form name="evgDocumentRevisionForm" style="margin: 10px">
        <div class="eventsTransparent">
            <div class="formHeader" layout-align="start center" flex>
                <h3>
                    <div layout="row" layout-align="start center">
                        <div style="padding-left: 5px;">Request Document Revision</div>
                    </div>
                </h3>
            </div>
            <div layout="row" flex style="margin: 20px">
                <p flex ng-bind-html="['Document Name: ' + ($ctrl.documentForRevisionRequest.name  || $ctrl.details.name || '-')].join(' ')"></p>
            </div>
            <div layout="row">
                <asset cls="input-icon" style="margin-top: 15px" src="search.svg"></asset>
                <autocomplete flex
                              name="revisionAssigneeAutocomplete"
                              label="Select revision assignee"
                              identifier="{{$ctrl.identifier}}"
                              action="$ctrl.onAutocompleteKeywordQuery($event)"
                              state-provider="rcoEvidenceDocRevisionCandidates"
                              state-path="docRevisionRequest.assignee"
                              validate="true"
                              required="true"
                              item-icon="user.svg"
                              item-props="['name']">
                </autocomplete>
            </div>
            <div layout-gt-xs="row">
                <input-text-area flex
                                 class="noMarginBottom"
                                 name="docRevisionRequestComment"
                                 rows="2"
                                 label="Request Comment"
                                 identifier="{{$ctrl.identifier}}"
                                 state-path="docRevisionRequest.description"
                                 required="true"
                                 max-length="1000">
                </input-text-area>
            </div>
            <div layout-gt-md="row">
                <input-date name="dueDate"
                            flex-gt-md="20"
                            class="noMarginBottom"
                            label="{{'COMMON.DATE.DUE_DATE' | translate}}"
                            identifier="{{$ctrl.identifier}}"
                            state-path="docRevisionRequest.dueDate"
                            min-date="$ctrl.minDueDate"
                            max-date="$ctrl.maxDueDate"
                            validate="true"
                            required="true">
                </input-date>
            </div>
            <div layout-xs="column" layout-gt-xs="row" layout-align="center center" class="tabs">
                <div layout-gt-sm="row" class="checkbox">
                    <input-checkbox label="Also Assign Improvement Action"
                                    identifier="{{$ctrl.identifier}}"
                                    state-path="alsoAssignImprovementAction">
                    </input-checkbox>
                </div>
                <div flex></div>
                <md-button class="btnTabsNav"
                           name="CANCEL"
                           aria-label="CANCEL"
                           ng-click="$ctrl.onCancel()">
                    <asset src="arrow_left.svg"></asset>CANCEL
                </md-button>
                <button type="submit"
                        class="md-button btnColorAccreditations"
                        aria-label="Request Document Revision"
                        ng-click="$ctrl.onSubmit()">Submit Revision Request
                </button>
            </div>
        </div>
    </ng-form>
    `
}
